import React from 'react';
export function ChristmasTrees() {
  return <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden" aria-hidden="true" data-id="element-37">
      {/* Bottom Left Tree */}
      <div className="absolute bottom-0 left-[-50px] md:left-10 transform scale-75 md:scale-100" data-id="element-38">
        <div className="relative w-40 h-64 flex flex-col items-center justify-end" data-id="element-39">
          {/* Trunk */}
          <div className="w-8 h-12 bg-amber-800 rounded-sm" data-id="element-40"></div>

          {/* Leaves Layers */}
          <div className="absolute bottom-10 w-40 h-32 bg-green-700 clip-triangle flex items-center justify-center" data-id="element-41">
            <div className="absolute top-10 left-8 w-3 h-3 bg-red-500 rounded-full shadow-sm" data-id="element-42"></div>
            <div className="absolute top-16 right-10 w-3 h-3 bg-yellow-400 rounded-full shadow-sm" data-id="element-43"></div>
          </div>
          <div className="absolute bottom-24 w-32 h-28 bg-green-600 clip-triangle flex items-center justify-center" data-id="element-44">
            <div className="absolute top-12 left-10 w-3 h-3 bg-blue-400 rounded-full shadow-sm" data-id="element-45"></div>
          </div>
          <div className="absolute bottom-36 w-24 h-24 bg-green-500 clip-triangle flex items-center justify-center" data-id="element-46">
            <div className="absolute top-10 right-6 w-3 h-3 bg-red-500 rounded-full shadow-sm" data-id="element-47"></div>
          </div>

          {/* Star */}
          <div className="absolute top-0 text-yellow-400 text-5xl drop-shadow-lg animate-pulse" data-id="element-48">
            ★
          </div>
        </div>
      </div>

      {/* Bottom Right Tree */}
      <div className="absolute bottom-0 right-[-50px] md:right-10 transform scale-75 md:scale-100" data-id="element-49">
        <div className="relative w-48 h-72 flex flex-col items-center justify-end" data-id="element-50">
          {/* Trunk */}
          <div className="w-10 h-14 bg-amber-800 rounded-sm" data-id="element-51"></div>

          {/* Leaves Layers */}
          <div className="absolute bottom-12 w-48 h-36 bg-green-800 clip-triangle" data-id="element-52">
            <div className="absolute top-14 left-12 w-4 h-4 bg-yellow-400 rounded-full shadow-sm" data-id="element-53"></div>
            <div className="absolute top-20 right-12 w-4 h-4 bg-red-500 rounded-full shadow-sm" data-id="element-54"></div>
          </div>
          <div className="absolute bottom-28 w-36 h-32 bg-green-700 clip-triangle" data-id="element-55">
            <div className="absolute top-16 left-10 w-3 h-3 bg-blue-300 rounded-full shadow-sm" data-id="element-56"></div>
          </div>
          <div className="absolute bottom-44 w-28 h-24 bg-green-600 clip-triangle" data-id="element-57">
            <div className="absolute top-12 right-8 w-3 h-3 bg-white rounded-full shadow-sm" data-id="element-58"></div>
          </div>

          {/* Star */}
          <div className="absolute top-0 text-yellow-300 text-6xl drop-shadow-lg animate-pulse" data-id="element-59">
            ★
          </div>
        </div>
      </div>

      {/* CSS Clip Path for Triangles */}
      <style data-id="element-60">{`
        .clip-triangle {
          clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
        }
      `}</style>
    </div>;
}